export const PATHWAY_STATUS_TEXT = 'Your school is currently on'
export const PROMPT_TEXT = 'To get the most out of this program, complete'
export const LINK_TEXT = 'Program Training'
